import { Text } from '@/components/ui/text';
import { Switch } from '@/components/ui/switch';
import { HStack } from '@/components/ui/hstack';
import React from 'react';

export default function SwitchableElement({ header, mainText, isChecked, onToggle, disabled }) {
    return (
        <>
            {header && <Text className="text-2xl mb-2 mt-1 text-secondary-900">{header}</Text>}
            <HStack className="justify-between items-center px-3 mb-2">
                <Text className="text-xl leading-2xl text-secondary-900">{mainText}</Text>
                <Switch value={isChecked} isDisabled={disabled} onToggle={() => onToggle()} trackColor={{ false: '#767577', true: '#0071DB' }} thumbColor={ '#FFFFFF' }/>
            </HStack>
        </>
    );
}
